module.exports = __webpack_public_path__ + "static/media/online-music-therapy.7b026c5b.jpg";